import styled from 'styled-components';
import { colors } from '~/styles/colors';

export const ScheduleSummaryContainer = styled.div`
  width: 386px;

  & > div > h1 {
    color: ${colors.text['primary-base']};
    font-weight: bold;
    font-size: 16px;
  }
`;

export const AssetsSummaryContainer = styled.div`
  display: flex;
  width: 100%;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;
